import axios from "axios";
import { LoaderFunctionArgs, redirect } from "react-router-dom";

import { EnumEndpoint } from "../type/EnumEndpoint";

interface ShoppingCartObj {
  [key: string]: string;
}

interface CheckoutItem {
  id: string;
  qty: string;
}

interface CheckoutResponse {
  url: string;
}

export default async function actionCheckout({ request }: LoaderFunctionArgs) {
  const formData = await request.formData();
  const shoppingCartString = formData.get("get-quote-shoppingcart") as string;
  const shoppingCartObj = JSON.parse(shoppingCartString) as ShoppingCartObj;
  const data = Object.entries(shoppingCartObj).reduce((prev, entry) => {
    prev.push({ id: entry[0], qty: entry[1] });
    return prev;
  }, [] as CheckoutItem[]);
  
  const result = await axios.post<CheckoutResponse>(EnumEndpoint.CHECKOUT, data, {
    headers: {
      "Content-Type": "application/json"
    } }).catch((err) => {
    console.log(err);
    return { data: undefined, errMsg: err.response?.data.message || (err.message + ". Please try again later.") }
  });

  if ("errMsg" in result) return result;
  
  const redirectUrl = result.data.url;
  if (!redirectUrl) return { errMsg: "Redirect has failed, please try again later" };

  return redirect(redirectUrl);
}